import { useState } from 'react';

const COOKIE_KEY = 'lxi_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(!localStorage.getItem(COOKIE_KEY));

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      background: '#0a0a0a', borderTop: '1px solid #d4af37',
      padding: '16px 24px', zIndex: 9999,
      display: 'flex', alignItems: 'center',
      justifyContent: 'space-between', gap: '16px',
      flexWrap: 'wrap',
    }}>
      <p style={{
        margin: 0, fontSize: '13px', color: '#aaa',
        maxWidth: '700px', lineHeight: '1.5',
      }}>
        Usamos cookies técnicas esenciales para el funcionamiento de la tienda. No usamos cookies
        de seguimiento ni publicidad.{' '}
        <a href="/cookies" style={{ color: '#d4af37' }}>Política de Cookies</a>.
      </p>
      <button
        onClick={accept}
        style={{
          background: '#d4af37', color: '#0a0a0a',
          border: 'none', padding: '10px 28px',
          fontWeight: '700', borderRadius: '4px',
          cursor: 'pointer', fontSize: '13px',
          whiteSpace: 'nowrap',
        }}
      >
        Entendido
      </button>
    </div>
  );
}
